import React from 'react'
import styled from 'styled-components'
import SlideElement from './components/SlideElement'
import BakeryInfo from './components/BakeryInfo'
import SellingNft from './components/SellingNft'
import SellingArtists from './components/SellingArtists'
import BakeryDrops from './components/BakeryDrops'
import MysteryBoxes from './components/MysteryBoxes'
import FeaturedArtists from './components/FeaturedArtists'
import TrendingCollections from './components/TrendingCollections'
import BakeryFooter from './components/BakeryFooter'

const HomeWrapper = styled.div`
  width: 100%;
  position: relative;
`

export default function Home() {
  return (
    <HomeWrapper>
      <SlideElement></SlideElement>
      <BakeryInfo></BakeryInfo>
      <SellingNft></SellingNft>
      <SellingArtists></SellingArtists>
      <BakeryDrops></BakeryDrops>
      <MysteryBoxes></MysteryBoxes>
      <FeaturedArtists></FeaturedArtists>
      <TrendingCollections></TrendingCollections>
      <BakeryFooter></BakeryFooter>
    </HomeWrapper>
  )
}

